// extracted by mini-css-extract-plugin
module.exports = {"base":"WidgetOrAdvertisement-m__base__ANxyF"};